export enum SearchFilterKeys {
	All = 'All',
	Aisle = 'Aisle',
	Department = 'Department',
	GreatPrice = 'Great Price',
	PiesAttributes = 'PiesAttributes',
}
